export const dateToString = (d, Min) => {
  const date = new Date();
  const min = date.getMinutes();
  date.setMinutes(min + Min);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
  const day = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate();
  const hours = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
  const minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
  const formatDate = year + '-' + month + '-' + day + " " + hours + ":" + minutes + ":" + seconds;
  return formatDate;
}
export const parseExamDate = (value) => {
  if (value == null || value === '') {
    return new Date(NaN)
  }
  if (value instanceof Date) {
    return new Date(value.getTime())
  }
  if (typeof value === 'number') {
    return new Date(value)
  }
  const normalizedValue = typeof value === 'string' ? value.replace(/-/g, '/') : value
  return new Date(normalizedValue)
}

export const getExamTimestamp = (value) => {
  return parseExamDate(value).getTime()
}

export const dateToString2 = (d, Min) => {
  const isSafari = localStorage.getItem('isSafari') === 'true'
  const date = parseExamDate(d)
  const min = date.getSeconds();
  date.setSeconds(min + Min);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
  const day = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate();
  const hours = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
  const minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
  const formatDate = year + '-' + month + '-' + day + " " + hours + ":" + minutes + ":" + seconds;
  if (isSafari) {
    return formatDate.replace(/-/g, '/');
  } else {
    return formatDate;
  }
}
export const dateMinutes = (time) => {
  var date2 = new Date();    // 结束时间

  var ms = Math.round(Math.abs(date2 - parseExamDate(time)) / 1000);
  return ms;
}
export const dateMinutes2 = (time1, time2) => {
  var date2 = parseExamDate(time1);    // 结束时间
  var ms = Math.round(Math.abs(date2 - parseExamDate(time2)) / 1000);
  return ms;
}
export const nowTime = (timestamp) => {
  var myDate = timestamp ? new Date(timestamp) : new Date();
  var year = myDate.getFullYear(); // 获取当前年
  var mon = myDate.getMonth() + 1 < 10 ? "0" + (myDate.getMonth() + 1) : myDate.getMonth() + 1; // 获取当前月
  var date = myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日
  var hour = myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours();// 获取当前时
  var minute = myDate.getMinutes() < 10 ? "0" + myDate.getMinutes() : myDate.getMinutes();// 获取当前分
  var seconds = myDate.getSeconds() < 10 ? "0" + myDate.getSeconds() : myDate.getSeconds();// 获取当前分
  return year + "-" + mon + "-" + date + " " + hour + ":" + minute + ":" + seconds;
}
export const getTime = (time) => {
  var hours = Math.floor(time / 3600);
  var minutes = Math.floor((time - (hours * 3600)) / 60);
  var seconds = time - (hours * 3600) - (minutes * 60);
  seconds = Math.round(seconds * 100) / 100
  var result = (hours < 10 ? "0" + hours : hours);
  result += ":" + (minutes < 10 ? "0" + minutes : minutes);
  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
  return result;
}
export const processDate = (time, time2, type) => {
  var nowTime = new Date();
  var nowYear = nowTime.getFullYear();
  var nowday = nowTime.getDate() < 10 ? "0" + nowTime.getDate() : nowTime.getDate(); // 获取当前日

  var times = new Date(time);
  var year = times.getFullYear();
  var mon = times.getMonth() + 1 < 10 ? "0" + (times.getMonth() + 1) : times.getMonth() + 1; // 获取当前月
  var day = times.getDate() < 10 ? "0" + times.getDate() : times.getDate(); // 获取当前日
  var hour = times.getHours() < 10 ? "0" + times.getHours() : times.getHours();// 获取当前时
  var minute = times.getMinutes() < 10 ? "0" + times.getMinutes() : times.getMinutes();// 获取当前分
  var seconds = times.getSeconds() < 10 ? "0" + times.getSeconds() : times.getSeconds();// 获取当前分

  var times2 = new Date(time2);
  var year2 = times2.getFullYear();
  // var mon2 = times2.getMonth() + 1 < 10 ? "0" + (times2.getMonth() + 1) : times2.getMonth() + 1; // 获取当前月
  // var day2 = times2.getDate() < 10 ? "0" + times2.getDate() : times2.getDate(); // 获取当前日
  // var hour2 = times2.getHours() < 10 ? "0" + times2.getHours() : times2.getHours();// 获取当前时
  // var minute2 = times2.getMinutes() < 10 ? "0" + times2.getMinutes() : times2.getMinutes();// 获取当前分
  // var seconds2 = times2.getSeconds() < 10 ? "0" + times2.getSeconds() : times2.getSeconds();// 获取当前分

  if (year2 === year) {
    if (nowday === day) {
      if (type) {
        return hour + ':' + minute + ':' + seconds
      }
      return mon + '-' + day + '  ' + hour + ':' + minute + ':' + seconds
    }
    if (nowYear === year) {
      return mon + '-' + day + '  ' + hour + ':' + minute + ':' + seconds
    }
    return year + '-' + mon + '-' + day + '  ' + hour + ':' + minute + ':' + seconds
  } else {
    return time
  }
}
export function getScaleNum() {
  const pageWidth = document.documentElement.clientWidth;
  const pageHeight = document.documentElement.clientHeight;
  let scaleNum = 1;
  // if(pageWidth/1920>pageHeight/1080){
  //   scaleNum = pageWidth/1920;
  //   console.log("------",scaleNum);
  // }else{
  //   scaleNum = pageHeight/1080;
  //   console.log("-++++++++++-",scaleNum)
  // }
  scaleNum = pageWidth / 1920;
  return scaleNum;
}
export function getPolygon(str, scaleNum) {
  const arr = str.split(",");
  return arr.map(item => {
    return (item + "").split(" ").map((num, index) => index ? num.split("px")[0] * scaleNum + "px" : "");
  }).map(item => {
    return item.join(" ");
  }).join(",");
}

export const ExamFileDecryptor = {
  keyStore: {
    0x01: '9ef5eb2e388a0f149cb85b070b013a217201b52260ba896926a4771d613e347e',
    0x02: '9142f9f7e88fb079002d97ab1434bec6f7a450230a5e601498d89b7c972185d6',
  },
  hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
      bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return bytes;
  },
  async decrypt(data) {
    const bytes = new Uint8Array(data);
    if (bytes[0] === 0x5B || bytes[0] === 0x7B) {
      return new TextDecoder().decode(bytes);
    }
    if (bytes.length < 0x18 + 16) throw new Error('File too short');
    const magic = String.fromCharCode(...bytes.slice(0, 4));
    if (magic !== 'ENC1') throw new Error('Invalid magic');
    const formatVersion = bytes[0x04];
    const keyVersion = bytes[0x05];
    const iv = bytes.slice(0x08, 0x14);
    const originalSize = new DataView(data).getUint32(0x14, false);
    const ciphertext = bytes.slice(0x18, bytes.length - 16);
    const authTag = bytes.slice(bytes.length - 16);
    if (formatVersion !== 0x01) throw new Error(`Unsupported format: ${formatVersion}`);
    const keyHex = this.keyStore[keyVersion];
    if (!keyHex) throw new Error(`Unknown key version: ${keyVersion}`);
    const cipherInput = new Uint8Array(ciphertext.length + authTag.length);
    cipherInput.set(ciphertext, 0);
    cipherInput.set(authTag, ciphertext.length);
    const cryptoKey = await crypto.subtle.importKey(
      'raw', this.hexToBytes(keyHex), { name: 'AES-GCM' }, false, ['decrypt']
    );
    const plainBuf = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv, tagLength: 128 }, cryptoKey, cipherInput
    );
    const plaintext = new Uint8Array(plainBuf);
    if (plaintext.length !== originalSize) throw new Error('Size mismatch');
    return new TextDecoder().decode(plaintext);
  },
  async fetchAndDecrypt(url) {
    const res = await fetch(url);
    const data = await res.arrayBuffer();
    return JSON.parse(await this.decrypt(data));
  },
};
